import { SkeletonItem, Text } from '@capsicum/common-web';

export const TotalBalanceSkeleton = () => (
	<Text variant="title1">
		<SkeletonItem height={33} inline width={220} />
	</Text>
);
